module.exports = __webpack_public_path__ + "a64d4968e028081118d874f6349bf95f.svg";